<div class="h-screen overflow-hidden">
  <app-header *ngIf="isHeader"></app-header>

  <div
    class="flex h-[calc(100vh-68px)]"
    *ngIf="isHeader && isSidebar; else fullHeightLayout"
  >
    <app-sidebar></app-sidebar>
    <div class="flex-1 overflow-auto bg-[#F5F5F5]">
      <div
        class="h-full overflow-auto"
        [ngClass]="{ 'p-10': (isHeader && isSidebar && lastRoute!='change-password') }"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <ng-template #fullHeightLayout>
    <div class="flex h-screen">
      <ng-container *ngIf="isSidebar"><app-sidebar></app-sidebar></ng-container>
      <div class="flex-1 overflow-auto bg-[#F5F5F5]">
        <div
          class="h-full overflow-auto"
          [ngClass]="{ 'p-10': (isHeader && isSidebar) }"
        >
          <router-outlet> </router-outlet>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<app-loader></app-loader>
